$ = require 'jquery'
Auth = require 'db/auth'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
l = require 'lib/localize'
PopOver = require 'views/lib/pop-over'
SelectMemberView = require 'views/member/select-member-view'
SelectFilterableView = require 'views/member/select-filterable-view'
Storage = require 'lib/storage'
Util = require 'lib/util'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'
searchFilter = require 'lib/util/text/search-filter'

RECENT_MENTIONS_KEY = 'recentMentions'
recentMentions = Storage.get(RECENT_MENTIONS_KEY) || []

module.exports = class AutoMentionerView extends View
  viewTitleKey: 'mention'

  initialize: ->
    if (org = @getCard()?.getBoard()?.getOrganization())
      @listenTo org.memberList, 'add remove reset', @frameDebounce @render

  events:
    'mouseenter .js-select-member': 'hoverItem'
    'click .js-select-member:not(.disabled)': 'insertMember'
    'click .js-select-all-card-members': 'selectAllCardMembers'
    'mouseenter .js-select-all-card-members': 'deselectMember'
    'click .js-select-all-board-members': 'selectAllBoardMembers'
    'mouseenter .js-select-all-board-members': 'deselectMember'
    'keydown': 'keydownEvent'
    'keyup .js-filter-mentionables': 'keyupEvent'

  render: ->
    view = @

    {
      @cardMentionables,
      @boardMentionables,
      @allMentionables
    } = @getMentionables()

    data = {}
    if @options.input
      data.input = true
    if @options.button
      data.button = true

    @$el.html(
      templates.fill(
        'popover_auto_mentioner',
        data
      )
    )

    @$mentionablesList = @$('.js-available-members')

    if @options.button
      @fillMentionables(@allMentionables)
    else if @options.input
      @filterMentionables()

    @

  getCard: ->
    @options.card

  getTextInput: ->
    $(@options.target)

  getMentionables: ->
    myId = Auth.myId()
    card = @getCard()
    board = card.getBoard()

    idsToMentionables = (ids, options = {}) =>
      _.chain(ids)
        .reject (id) =>
          (id == myId && !@options.selfMention) ||
          board.isDeactivated(@modelCache.get('Member', id))
        .sortBy (id) ->
          index = recentMentions.indexOf(id)
          if index == -1
            recentMentions.length
          else
            index
        .map (id) =>
          _.extend {}, options, {
            id: id,
            names: Util.getMemNameArrayFromId(@modelCache, id),
            type: 'member'
          }
        .value()

    cardMentionables = idsToMentionables(card.getIdCardMems())
    boardMentionables = idsToMentionables(board.getIdBoardMems())

    orgMentionables =
      if (org = board.getOrganization())?
        idValidMembers = []
        idInvalidMembers = []

        activeMembers = org.memberList.filter (member) ->
          !org.isDeactivated(member)

        if board.isPrivate()
          if org.isFeatureEnabled('superAdmins')
            membersByMemberType = _.groupBy activeMembers, (member) =>
              if org.ownedByMember(member) then 'admin' else 'not-admin'

            idValidMembers = _.pluck(membersByMemberType['admin'], 'id')
            idInvalidMembers = _.pluck(membersByMemberType['non-admin'], 'id')
          else
            idInvalidMembers = _.pluck(activeMembers, 'id')
        else
          idValidMembers = _.pluck(activeMembers, 'id')

        [
          idsToMentionables(idValidMembers)...,
          idsToMentionables(idInvalidMembers, {
            disabled: true,
            extraText: l(['mention member', 'board not team visible'])
          })...
        ]
      else
        []

    extraMentionables = [{
      type: 'extra',
      text: 'card',
      names: ["all", "card"],
      extraText: l(['automentioner', "all-members-on-card"]),
      mentionCount: cardMentionables.length
    }, {
      type: 'extra',
      text: 'board',
      names: ["all", "board"],
      extraText: l(['automentioner', "all-members-on-board"]),
      mentionCount: boardMentionables.length
    }]

    uniqMentionables = _.uniq([
      cardMentionables...
      boardMentionables...
      orgMentionables...
    ], (mentionable) -> mentionable.id)
    allMentionables = uniqMentionables.concat(extraMentionables)

    cardMentionables: cardMentionables
    boardMentionables: boardMentionables
    orgMentionables: orgMentionables
    allMentionables: allMentionables

  clearMentionables: ->
    @$mentionablesList.empty()

  keydownEvent: (e) ->
    if Keyboard.getKey(e) in [Keys.Enter, Keys.Tab]
      Util.stop(e)
      @$mentionablesList.find('.item.selected:first .js-select-member').click()
      return

  keyupEvent: (e) ->
    key = Keyboard.getKey(e)

    if key in [Keys.Enter, Keys.Tab, Keys.ArrowLeft, Keys.ArrowRight]
      return

    else if key in [Keys.ArrowUp, Keys.ArrowDown]
      Util.stop(e)
      Util.navMenuList(@$mentionablesList, '.item', key)
      return

    else
      @filterMentionables()

  filterMentionables: (e) ->
    @clearMentionables()

    if @options.button
      term = $('.js-filter-mentionables').val().trim().toLowerCase()
    else if @options.input
      $textInput = @getTextInput()
      word = Util.getWordFromCaret($textInput)
      term = word.str.substring(1).toLowerCase()

    matches = @filterMentionablesForMatches(term)

    # hide if there are no results
    if @options.input && matches.length == 0
      @setTimeout ->
        PopOver.hide()
      , 5
      return

    @fillMentionables(matches)
    Util.selectMenuItem(@$mentionablesList, '.item', @$mentionablesList.find('.item').first())

  filterMentionablesForMatches: (term) ->
    satisfiesSearch = searchFilter(term)

    _.filter @getMentionables().allMentionables, (filterable) ->
      satisfiesSearch(filterable.names)

  hoverItem: (e) ->
    $elem = $(e.target).closest('.item')
    Util.selectMenuItem(@$mentionablesList, '.item', $elem)

  deselectMember: (e) ->
    @$mentionablesList.find('.item').removeClass('selected')

  fillMentionables: (filterables) ->
    filterables = _.groupBy(filterables, 'type')

    entries = (filterables.member || []).map ({ id, disabled, extraText }) =>
      member: @modelCache.get('Member', id)
      disabled: disabled
      extraText: extraText

    @$mentionablesList.empty()

    for { member, disabled, extraText } in entries
      @appendSubview(@subview(SelectMemberView, member, { disabled, extraText }), @$mentionablesList)

    if filterables.extra?
      for extra in filterables.extra
        @$mentionablesList.append((new SelectFilterableView(extra)).render().el)

    @$('.js-empty-list').toggleClass('hide', _.keys(filterables).length > 0)

    return

  insertMember: (e) ->
    Util.stop(e)

    track("Card Detail", "Mention Member Autocomplete", "Insert")

    autocompleteText = $(e.currentTarget).attr('autocompleteText')

    @saveRecent($(e.currentTarget).attr('idMember'))

    $textInput = @getTextInput()
    if @options.input
      word = Util.getWordFromCaret($textInput)
      Util.insertSelection($textInput, "@#{autocompleteText} ", word.start, word.end)
    else
      caretPosition = Util.getCaretPosition($textInput)
      if caretPosition?
        word =
          start: caretPosition
          end: caretPosition

      Util.insertSelection($textInput, "@#{autocompleteText} ", word?.start, word?.end)
    PopOver.hide()
    return

  selectAllCardMembers: (e) ->
    Util.stop(e)

    track("Card Detail", "Mention Member Autocomplete", "Insert - All Card Members")

    $textInput = @getTextInput().focus()
    insertStr = '@card '
    Util.insertSelection($textInput, insertStr)
    PopOver.hide()
    return

  selectAllBoardMembers: (e) ->
    Util.stop(e)

    track("Card Detail", "Mention Member Autocomplete", "Insert - All Board Members")

    $textInput = @getTextInput().focus()
    insertStr = '@board '
    Util.insertSelection($textInput, insertStr)
    PopOver.hide()
    return

  saveRecent: (idMember) ->
    recent = Storage.get(RECENT_MENTIONS_KEY) || []
    recent = _.chain([idMember, recent...])
      .uniq()
      .first(16)
      .value()
    Storage.set(RECENT_MENTIONS_KEY, recent)
    recentMentions = recent





// WEBPACK FOOTER //
// ./app/scripts/views/internal/autocomplete/auto-mentioner-view.coffee